import React, { useEffect, useState } from "react";
import "../../styles/bbps.css";
import Header from "../../components/Header/Header.js";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setDetailsToSend } from "../../redux/slice/detailsToSendSlice";
import { ImagesPath } from "../../Common/imagespath/imagespath";
import { isFeatureServiceActive } from "../../Common/serviceActiveCheck/serviceActiveCheck.js";
import { Modal as AntdModal } from "antd";
import { data } from "../../Common/Text/NormalText.js";

const servicesData = [
  {
    category: "Recharges",
    services: [
      {
        name: "Mobile Postpaid",
        image: ImagesPath?.BBPS?.mobilePostpaid,
        route: "/bbps/block",
        curor: "block",
      },
      {
        name: "Mobile Prepaid",
        image: ImagesPath?.BBPS?.mobilePrepaid,
        route: "/bbps/Mobile Prepaid",
      },
      { name: "DTH", image: ImagesPath?.BBPS?.dth, route: "/bbps/DTH" },
      {
        name: "FASTag",
        image: ImagesPath?.BBPS?.fastTag,
        route: "/bbps/FastTag",
      },
      {
        name: "Broadband LandLine",
        image: ImagesPath?.BBPS?.broadband,
        route: "/bbps/Broadband Postpaid",
      },
    ],
  },
  {
    category: "Utilities",
    services: [
      {
        name: "Electricity",
        image: ImagesPath?.BBPS?.electricity,
        route: "/bbps/Electricity",
      },
      { name: "Water", image: ImagesPath?.BBPS?.water, route: "/bbps/Water" },
      {
        name: "Piped Gas",
        image: ImagesPath?.BBPS?.pipedGas,
        route: "/bbps/Gas",
      },
      {
        name: "LPG Cylinder",
        image: ImagesPath?.BBPS?.lpgCylinder,
        route: "/bbps/LPG Gas",
      },
      {
        name: "Municipal Tax",
        image: ImagesPath?.BBPS?.municipalTax,
        route: "/bbps/Municipal Taxes",
      },
      {
        name: "Education",
        image: ImagesPath?.BBPS?.educationFee,
        route: "/bbps/Education Fees",
      },
      //  { name: "Landline", image: landline, route: "/bbps/block" },
    ],
  },

  {
    category: "Finance",
    services: [
      {
        name: "Credit Card",
        image: ImagesPath?.BBPS?.creditCard,
        route: "/bbps/Credit Card",
      },
      {
        name: "Loan Repayment",
        image: ImagesPath?.BBPS?.loanRepayment,
        route: "/bbps/Loan Repayment",
      },
      {
        name: "Insurance",
        image: ImagesPath?.BBPS?.insurance,
        route: "/bbps/Insurance",
      },
    ],
  },
];

const BBServices = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const detailsToSend = useSelector((state) => state?.details?.details);
  const features = useSelector((state) => state.activeFeatures.features);
  console.log("detailsToSend in bbps services ===>>", detailsToSend);

  useEffect(() => {
    sessionStorage.clear();
  }, []);
  const handlePage = (service) => {
    if (service.route) {
      if (service.name?.toLowerCase() == "credit card") {
        if (
          !isFeatureServiceActive(
            features,
            "Credit_Card_Bill_Payment",
            "Credit_Card_Bill_Payment"
          )
        ) {
          return AntdModal.info({
            title: "Service Unavailable",
            content: <p>{data?.serviceUnavailable}</p>,
            onOk() {
              console.log("User acknowledged wallet inactivity");
            },
          });
        } else {
          dispatch(
            setDetailsToSend({
              ...detailsToSend,
              payOutFee: "0",
              payOutPercentage: 0,
              payOutChargedAmount: 0,
              chargedAmount: 0,
              creditCardNumber: "",
              paymentSource: "webApp",
              serviceName: service.name,
            })
          );
          navigate(service.route, {
            state: {
              record: service.name,
              cardData: "",
              billUnique: "",
              key: "",
            },
          });
        }
      } else {
        dispatch(
          setDetailsToSend({
            ...detailsToSend,
            payOutFee: "0",
            payOutPercentage: 0,
            payOutChargedAmount: 0,
            chargedAmount: 0,
            creditCardNumber: "",
            paymentSource: "webApp",
            serviceName: service.name,
          })
        );
        navigate(service.route, {
          state: {
            record: service.name,
            cardData: "",
            billUnique: "",
            key: "",
          },
        });
      }
    }
  };

  return (
    <>
      <div className="bbps-services-bg">
        <div className="content-header-profile-bbps">
          <Header title="Pay Bills" />

          <div className="bbpsDiv">
            <div>
              <div className="headerImg">
                <img
                  className="paybills-Bharatconnect"
                  src={ImagesPath?.BBPS?.BharatConnection}
                  alt="Bharat Logo"
                />
              </div>
            </div>
            <div className="serviceProviderDiv">
              {servicesData.map((category, index) => (
                <div className="servicesDiv" key={index}>
                  <h6 style={{ textAlign: "left" }}>{category.category}</h6>
                  <div className="subservicesDiv">
                    {category.category === "Utilities" &&
                      category.services.map((service, idx) => (
                        <div
                          className="subserviceName"
                          key={idx}
                          onClick={() => handlePage(service)}
                        >
                          <div className="iconDiv-v">
                            <img
                              className="image_width_v"
                              src={service.image}
                              alt="No Image"
                            />
                          </div>
                          <div>
                            <p>{service.name}</p>
                          </div>
                        </div>
                      ))}
                    {category.category !== "Utilities" &&
                      category.services.map((service, idx) => (
                        <div
                          className="subserviceName"
                          key={idx}
                          onClick={() => handlePage(service)}
                        >
                          <div className="iconDiv-v">
                            <img
                              className="image_width_v"
                              src={service.image}
                              alt="No Image"
                            />
                          </div>
                          <div>
                            <p>
                              {service.name?.split("")?.length > 1
                                ? service.name
                                    ?.split(" ")
                                    .map((word, index) => (
                                      <p key={index}>{word}</p>
                                    ))
                                : service.name}
                            </p>
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BBServices;
